<template>
    <div class="w-full sm:w-1/2 xl:w-1/4 p-4 space-y-2">
      <!-- Profile Section -->
      <div class="bg-white shadow-lg rounded-lg border-t-4 border-gray-600 p-6">
        <div class="flex flex-col items-center space-y-4">
          <img v-if="schoolLogo" :src="schoolLogo" alt="School logo" class="w-16 h-16 border-4 border-gray-300 rounded-full"/>
          <i v-else class="pi pi-graduation-cap text-primary" style="font-size: 3rem;"></i>
          <div class="text-center">
            <h2 class="font-bold text-xl text-gray-800">BODUNDE K.D</h2>
            <p class="text-gray-500">@ronex212</p>
          </div>
        </div>
        <div class="mt-4 space-y-2">
          <div class="flex justify-between text-gray-700">
            <p class="font-medium">Email:</p>
            <p class="text-blue-500">fihs@gmail.com</p>
          </div>
          <div class="flex justify-between text-gray-700">
            <p class="font-medium">Role:</p>
            <p class="text-blue-500">Not started</p>
          </div>
          <div class="flex justify-between text-gray-700">
            <p class="font-medium">Account:</p>
            <p class="text-primary">Active</p>
          </div>
        </div>
        <button type="button"
                class="mt-6 py-2 px-4 bg-gray-700 hover:bg-gray-500 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none rounded-lg">
          Edit Profile
        </button>
      </div>
  
      <!-- About Me Section -->
      <div>
        <h2 class="bg-gray-700 text-white py-3 px-4 rounded-t-lg">About Me</h2>
        <div class="bg-white shadow-lg rounded-b-lg p-4 space-y-4">
          <div>
            <h3 class="font-semibold text-gray-800">Education</h3>
            <p class="text-gray-700">B.Sc Computer Science from University of Ibadan</p>
          </div>
          <div>
            <h3 class="font-semibold text-gray-800">Location</h3>
            <p class="text-gray-700">Nigeria</p>
          </div>
          <div>
            <h3 class="font-semibold text-gray-800">Skills</h3>
            <p class="text-gray-700">Design, Communication</p>
          </div>
          <div>
            <h3 class="font-semibold text-gray-800">Notes</h3>
            <p class="text-gray-700">fbbeb vqebieq jlvleqi ujiqv</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup lang="ts">
  
import { useBranding } from '@/composables/useBranding';

const { schoolLogo } = useBranding();

const isAccordionOpen = ref(false);
  
const toggleAccordion = () => {
  isAccordionOpen.value = !isAccordionOpen.value;
};
</script>
  
  <style scoped>
  /* Add any scoped styles if needed */
  </style>
  
